import { Container, Row, Col } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { getLateInfo } from '../../../services/ApiGetLateThisWeek';
import Moment from 'moment';
import { useTranslation } from 'react-i18next';
import { LateThisWeek } from '../../../model/datatype';

export const TimeLateThisWeek = (props: any) => {
  let { t } = useTranslation();
  const [data, setData] = useState<LateThisWeek | null>(null);

  useEffect(() => {
    if (data === null) {
      getLateInfo(0, 0, props.email).then((response: any) => {
        const getData: any = response;
        setData(getData);
      });
    }
  }, [data]);
  //console.log('lasteData=',data);
  return (
    <div className="TimeInout_ThisWeek_detail text-center">
      <Row className="m-auto">
        <Col className="px-1">
          <div className="time_late_this_week_detail_box">
            <div className="TimeLate_ThisWeek_detail_text">
              {t('time_list_box.timeanddate_late_this_week.title')}
            </div>
            <Row className="late_this-week-title-box m-1">
              <Col className="this-week-title px-1">
                {t('time_list_box.timeanddate_late_this_week.date')}
              </Col>
              <Col></Col>
              <Col className="this-week-title px-1">
                {t('time_list_box.timeanddate_late_this_week.overtime')}
              </Col>
            </Row>
            <div className="w-100 table-container">
              {typeof data?.lateDetails !== 'undefined' ? (
                data?.lateDetails.length > 0 ? (
                  data?.lateDetails.map((item: any, index: number) => (
                    <Row className="late_time-in-out-list m-1 mt-3" key={index}>
                      <Col className="late_this-week-title-val px-1  text-center">
                        {Moment(item.dateWork).format('DD/M/YYYY')}
                      </Col>
                      <Col></Col>
                      <Col className="late_this-week-title-val px-1 text-center">
                        {item.qtyStr}{' '}
                        {t('time_list_box.timeanddate_late_this_week.unit')}
                      </Col>
                    </Row>
                  ))
                ) : (
                  <div className="loader-data text-notfound">
                    {t('text_notfound')}
                  </div>
                )
              ) : (
                <div className="loader-data">
                  <div className="spinner"></div>
                </div>
              )}
            </div>
            <Row className="late_time-in-out-list  line-total m-1 mt-3">
              <Col className="this-week-title-val px-1 text-center">
                <strong className="late_time-in-out-this-week-total">
                  {t('time_list_box.timeanddate_late_this_week.total')}
                </strong>
              </Col>
              <Col></Col>
              <Col className="this-week-title-val px-1  text-center pb-0">
                <strong className="late_time-in-out-this-week-total">
                  {data?.summary}{' '}
                  {t('time_list_box.timeanddate_late_this_week.unit')}
                </strong>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="m-2"></Col>
      </Row>
    </div>
  );
};
